import filter from 'lodash/filter';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';

import Events from '../components/events';

import eventPredicateFactories from '../filters/event-predicates';
import getAppStateHash from '../selectors/get-app-state-hash';

export default withRouter(
	connect(
		(state, ownProps) => ({
			isExpanded: ownProps.isExpanded,
			events: ownProps.events,
			tags: state.featureSources.all.data.metadata.tags,
			featureId: ownProps.match.params.featureId,
			appStateHash: getAppStateHash(state),
			eventPredicates: filter(
				eventPredicateFactories.map((factory) => factory(state.app))
			),
		}),
	)(Events)
);
